<template>
  <div class="bg-dark">
    <div
      id="competence"
      class="container text-white text-start"
      style="border-top: 1px solid #454545; padding-top: 5rem"
    >
      <h1 class="header-title pt-5 text-center">Unser Versprechen</h1>

      <h2 class="sub-title text-center pt-3 pb-5">
        Du bist das Herz, wir sind das Handwerk.
      </h2>

      <div
        v-if="viewStore.isMobile"
        class="px-3 pt-3 lh-base"
        style="padding-bottom: 4rem"
      >
        <div class="pb-5">
          <h1>Qualität</h1>
          <div v-if="currentRoute == '/podcast'" class="fs-5">
            <p>
              Was wir die anbieten, klingt einfach gut! Unsere Sound-Engineers
              sind akademisch ausgebildet und echte Profis. Mit jahrelanger
              Erfahrung in der Audio- und Videoproduktion liefern wir
              Kreativität und Qualität, die beeindruckt.
            </p>
          </div>
          <div v-if="currentRoute == '/hoerbuch'" class="fs-5">
            <p>
              Wir schöpfen unsere Leistung & Qualität aus einem professionellen
              Pool kreativer Köpfe mit langjähriger Erfahrung. Unser Team
              besteht aus akademisch ausgebildeten Sound-Engineers die ihr
              Handwerk verstehen.
            </p>
          </div>
        </div>

        <div class="pb-5">
          <h1>Persönlichkeit</h1>
          <div class="fs-5">
            <p>
              Bei uns wirst du gut aufgenommen! Jedes unser einzelnen Projekte
              wird absolut individuell, persönlich und mit viel Liebe zum Detail
              begleitet. Wir legen großen Wert auf eine wertschätzende und
              persönliche Zusammenarbeit.
            </p>
          </div>
        </div>

        <div class="pb-5">
          <h1>Expertise</h1>
          <div class="fs-5">
            <p>
              You know what - We know how! Unser Team verfügt über langjährige
              und umfangreiche Podcast-Expertise, mit der wir dich auf deiner
              Podcast Reise begleiten. Wir entwickeln Formate, die crossmedial
              erfolgreich sind.
            </p>
          </div>
        </div>
      </div>
      <!-- Desktop -->
      <div
        v-else
        class="row gx-5 pt-5"
        style="padding-top: 6rem; padding-bottom: 6rem"
      >
        <div class="col">
          <h1>Qualität</h1>
          <div v-if="currentRoute == '/podcast'" class="fs-5 lh-lg pt-3">
            <p>
              Was wir die anbieten, klingt einfach gut! Unsere Sound-Engineers
              sind akademisch ausgebildet und echte Profis. Mit jahrelanger
              Erfahrung in der Audio- und Videoproduktion liefern wir
              Kreativität und Qualität, die beeindruckt.
            </p>
          </div>
          <div v-if="currentRoute == '/hoerbuch'" class="fs-5 lh-lg pt-3">
            <p>
              Unser Team besteht aus akademisch ausgebildeten Sound-Engineers.
              Unser großer Erfahrungsschatz liefert perfekte Hörbuchqualität in
              bester Aufnahmeatmosphäre.
            </p>
          </div>
        </div>

        <div class="col">
          <h1>Persönlichkeit</h1>
          <div v-if="currentRoute == '/podcast'" class="fs-5 lh-lg pt-3">
            <p>
              Bei uns wirst du gut aufgenommen! Jedes unser einzelnen Projekte
              wird absolut individuell, persönlich und mit viel Liebe zum Detail
              begleitet. Wir legen großen Wert auf eine wertschätzende und
              persönliche Zusammenarbeit.
            </p>
          </div>
          <div v-if="currentRoute == '/hoerbuch'" class="fs-5 lh-lg pt-3">
            <p>
              Jedes unser einzelnen Hörbücher wird individuell, persönlich, mit
              viel Liebe zum Detail konzipiert produziert und betreut.
            </p>
          </div>
        </div>

        <div class="col">
          <h1>Expertise</h1>
          <div v-if="currentRoute == '/podcast'" class="fs-5 lh-lg pt-3">
            <p>
              You know what - We know how! Unser Team verfügt über langjährige
              und umfangreiche Podcast-Expertise, mit der wir dich auf deiner
              Podcast Reise begleiten. Wir entwickeln Formate, die crossmedial
              erfolgreich sind.
            </p>
          </div>
          <div v-if="currentRoute == '/hoerbuch'" class="fs-5 lh-lg pt-3">
            <p>
              Wir beraten dich allumfassend. Vom kostenlosen Beratungsgespräch,
              über die Empfehlung passender Sprecher:in bis hin zur
              Distribution.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();

const router = useRouter();
const currentRoute = router.currentRoute.value.path;
</script>

<style scoped>
p {
  color: rgb(190, 190, 190);
}

h1 {
  font-weight: 900;
}

.sub-title {
  color: rgb(190, 190, 190);
  font-weight: 200;
  font-size: 2.3rem;
}
</style>
